import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Alert, Button, Col, FormControl, Glyphicon, OverlayTrigger, Popover, Row } from 'react-bootstrap'
import axios from 'axios'
import swal from 'sweetalert'
import { handleErrorFetchingData } from "../../../../functions/errorHandling";


class DataSource extends Component {
  state = {
    url: this.props.dataSource.url,
    name: this.props.dataSource.name,
    client: this.props.dataSource.client,
    trainingMaterials: this.props.dataSource.training_materials,
    dataDateRange: this.props.dataSource.data_date_range,
    maxRequestTime: this.props.dataSource.max_request_time,
    editable: false,
    showAlert: false
  }

  handleCancelEdit = () => {
    this.props.handleGetDataSourceObject()
  }

  handleInput = (e) => this.setState({ [e.target.name]: e.target.value })

  handleAddTrainingMaterial = () => {
    const trainingMaterials = [ ...this.state.trainingMaterials, { name: "", material_url: "" } ]
    this.setState({ trainingMaterials })
  }

  handleRemoveTrainingMaterial = (index) => {
    const trainingMaterials = [ ...this.state.trainingMaterials ]
    trainingMaterials.splice(index, 1)
    this.setState({ trainingMaterials })
  }

  handleEditTrainingMaterial = (index, field, value) => {
    const trainingMaterials = [ ...this.state.trainingMaterials ]
    trainingMaterials[index][field] = value
    this.setState({ trainingMaterials })
  }

  handleSave = () => {
    const { handleChangeDisplayValue, clients, handleGetDataSourceObject } = this.props
    const { url, client, name, trainingMaterials, dataDateRange, maxRequestTime } = this.state

    this.setState({ showAlert: false }, () => {

      if (!name || !dataDateRange || !maxRequestTime) {
        this.setState({ showAlert: true })
        return
      }
      if (trainingMaterials.length) {
        let incompleteMaterial = trainingMaterials.find(material => !material.name || !material.material_url)
        if (incompleteMaterial) {
          this.setState({ showAlert: true })
          return
        }
      }
      swal({
        text: `Updating data source... Please stand by.`,
        icon: require("../../../../static/images/spinner.gif"),
        button: false
      })

      const editedDataSource = {
        client,
        name,
        training_materials: trainingMaterials,
        data_date_range: dataDateRange,
        max_request_time: maxRequestTime
      }

      axios.patch(url, editedDataSource, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        swal({
          title: "Success",
          text: `Data source ${name} has been updated`,
          icon: "success",
          button: "Continue",
        })
        handleChangeDisplayValue("displayName", name)
        handleChangeDisplayValue("displayClientName", clients.find(clientObject => clientObject.url === client).name)
        handleGetDataSourceObject()
      }).catch(error => {
        handleErrorFetchingData(error, "There was an error in updating the data source")
        console.log(error)
      })
    })
  }

  generateTrainingMaterials = () => {
    const { trainingMaterials, editable } = this.state
    if (!trainingMaterials.length) {
      if (editable) return null
      return <div>There are no training materials associated with this data source.</div>
    }

    return (
      <table className="data-source-form-table" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th><h5>Name { editable && <span className="required">*</span> }</h5></th>
            <th><h5>URL { editable && <span className="required">*</span> }</h5></th>
            { editable && <th></th> }
          </tr>
        </thead>
        <tbody>
          {
            trainingMaterials.map((trainingMaterial, index) => (
              <tr key={index}>
                <td style={{ padding: "0 5px 5px 0" }}>
                  <FormControl
                    id="formControlProjectTitle"
                    value={trainingMaterial.name}
                    onChange={(e) => this.handleEditTrainingMaterial(index, "name", e.target.value)}
                    placeholder="Enter a name"
                    disabled={ !editable }
                  />
                </td>
                <td style={{ padding: "0 0 5px 0" }}>
                  <FormControl
                    id="formControlProjectTitle"
                    value={trainingMaterial.material_url}
                    onChange={(e) => this.handleEditTrainingMaterial(index, "material_url", e.target.value)}
                    placeholder="Enter a url"
                    disabled={ !editable }
                  />
                </td>
                { editable &&
                  <td style={{ padding: "0 0 5px 5px" }}>
                    <Button
                      bsStyle="danger"
                      style={{ width: "100%", margin: "0" }}
                      onClick={() => this.handleRemoveTrainingMaterial(index)}
                    >
                      <Glyphicon glyph="remove"/>
                    </Button>
                  </td>
                }
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }

  render() {
    const { name, client, dataDateRange, maxRequestTime, editable, showAlert } = this.state
    const { clients, handleDeleteDataSource } = this.props

    const clientOptions = clients.map(client => {
      if (client.managed_by_genesis) {
        return (
          <option key={ client.url } value={ client.url }>
            { client.name } { client.short_code }
          </option>
        )
      } else {
        return null
      }
    })
    return (
      <div className="data-source">
        <Row>
          <Col xs={6} sm={6} md={6}>
            <h5>Name { editable && <span className="required">*</span> }</h5>
            <FormControl
              value={ name }
              disabled={ !editable }
              name="name"
              onChange={ this.handleInput }
            />
          </Col>
          <Col xs={6} sm={6} md={6}>
            <h5>Client { editable && <span className="required">*</span> }</h5>
            <FormControl
              componentClass="select"
              placeholder="select"
              value={ client }
              name="client"
              onChange={ this.handleInput }
              disabled={ !editable }
            >
              <option value="">Select a client</option>
              { clientOptions }
            </FormControl>
          </Col>
        </Row>
        <Row>
          <Col xs={6} sm={6} md={6}>
            <h5>Duration of Access { editable && <span className="required">*</span> }</h5>
            <FormControl
              value={ maxRequestTime }
              disabled={ !editable }
              type="number"
              min="30"
              name="maxRequestTime"
              onChange={ this.handleInput }
            />
          </Col>
          <Col xs={6} sm={6} md={6}>
            <h5>Data Date Range { editable && <span className="required">*</span> }</h5>
            <FormControl
              value={ dataDateRange }
              disabled={ !editable }
              name="dataDateRange"
              onChange={ this.handleInput }
            />
          </Col>
        </Row>
        <div>
          <h5>Training Materials</h5>
          { this.generateTrainingMaterials() }
          { editable && <Button onClick={ this.handleAddTrainingMaterial }>Add Training Material</Button> }
        </div>
        { showAlert &&
          <React.Fragment>
            <br/>
            <Alert
              bsStyle="danger"
              onDismiss={ () => this.setState({ showAlert: false }) }
            >
              <h4>Please fill out all required fields</h4>
              <p>
                Required fields are marked with <span className="required">*</span>
              </p>
            </Alert>
          </React.Fragment>
        }
        <div style={{ float: "right" }}>
          { editable ?
            <React.Fragment>
              <Button className="request-action-btn" onClick={ this.handleSave } bsStyle="primary">Save</Button>
              <Button className="request-action-btn" onClick={ this.handleCancelEdit } bsStyle="danger">Cancel</Button>
            </React.Fragment>
            :
            <React.Fragment>
              <Button
                className="request-action-btn"
                onClick={ () => this.setState({ editable: true })}
                bsStyle="primary"
              >
                Edit
              </Button>
              <OverlayTrigger
                placement="top"
                trigger="click"
                rootClose
                overlay={
                  <Popover id='manager-info-popover' title="Delete Request">
                    <p>
                      Are you sure you want to delete this data source.
                    </p>

                    <center>
                      <Button
                        className="request-action-btn"
                        bsStyle="danger"
                        onClick={ handleDeleteDataSource }
                      >
                        Delete
                      </Button>
                    </center>
                  </Popover>
                }
              >
                <Button className="request-action-btn" bsStyle="danger">
                  {/*<Glyphicon glyph="remove"/>*/}
                  Delete
                </Button>
              </OverlayTrigger>
            </React.Fragment>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    clients: state.manageLogin.clients
  }
}

export default connect(mapStateToProps)(DataSource)


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/components/DataSource.js